<script>
    export let style = "regular";
    export let icon = undefined;
    export let tooltip = "";
    export let size = "normal";

    function getStyle(i) {
        let s = "fa";
        switch (style) {
            case "solid":
                s += "s";
                break;
            case "light":
                s += "l";
                break;
            default:
                s += "r";
        }
        return s + " fa-" + icon;
    }

    function sizeClass(w) {
        switch (w) {
            case "large":
                return "icon-large";
            case "larger":
                return "icon-larger";
            case "normal":
                return "icon-normal";
            case "small":
                return "icon-small";
            case "x-large":
                return "icon-x-large";
            case "xx-large":
                return "icon-xx-large";
        }
        return "icon-normal";
    }
</script>

{#if !!icon}
    <i class="{getStyle(icon)} {sizeClass(size)} icon" title={tooltip} />
{/if}

<style>
    .icon {
      
    }

    .icon-large {
        font-size: 2rem;
    }

    .icon-x-large {
        font-size: 3rem;
    }

    .icon-xx-large {
        font-size: 6rem;
    }

    .icon-larger {
        font-size: 1.5rem;
    }

    .icon-normal {
        font-size: 1rem;
    }

    .icon-small {
        font-size: 0.5rem;
    }
</style>
